import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import { Grid } from '@mui/material';
import { IListItem } from './IListItem';
import './listItem.css';


export default function ListItem({
    status,
    specialStatus,
    title,
    id,
    icon,
    onClick,
    borderColor,
    color,
    isShown = true,
    titleCenter,
    infoIcon,
}: IListItem) {



    return (
        <>
            <Grid
                className={`${borderColor != undefined ? borderColor : 'none'} bg-[var(--input-bg-color)]`}
                style={{
                    border: '1.5px solid var(--border-color)',
                    height: '80px',
                    // margin: 'auto',
                    borderRadius: '5px',
                    alignContent: 'center',
                    marginTop: '10px',
                }}
                container
                spacing={0}
                onClick={() => onClick!()}
            >
                <Grid container item spacing={0} xs={10}
                // style={{ height: "100%" }}
                >
                    {icon ? (
                        <div
                            style={{
                                display: 'inline-block',
                                marginRight: titleCenter ? '10px' : '20px',
                                alignSelf: 'center',
                                // height: "100%"

                            }}
                        >
                            {icon}
                        </div>
                    ) : null}
                    <div style={{ display: 'inline-block', marginRight: '15px', alignSelf: titleCenter ? "center" : "" }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: "14px", fontWeight: "bold", }} className={"text-sm mb-2 text-[var(--primary-text-color)] " + (color != undefined ? color : "primaryColorLight-900")}>{title}</span>

                            {specialStatus != null ? specialStatus :
                                <span className="font-normal text-xs primaryColorLight-100" style={{ float: "right", fontSize: "12.5px" }}>
                                    {status}
                                </span>}



                        </div>
                    </div>
                </Grid>
                <Grid item xs={2} className="leftSide" spacing={0}>
                    {infoIcon ?
                        <>
                            {infoIcon}
                        </> :
                        isShown ? <ChevronLeftOutlinedIcon
                            className={"primaryColorLight-100"}
                            style={{ width: '24px', height: '24px' }}
                        /> : <></>}
                </Grid>
            </Grid>
        </>
    );
}
